import { Component, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { AlertsService, Alert, AlertType } from 'src/app/providers/services/alerts.service';
import { Subscription } from 'rxjs';
import { CONSTANTS } from 'src/app/constants';

@Component({
    selector: 'app-alerts',
    templateUrl: './alerts.component.html',
    styleUrls: ['./alerts.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AlertsComponent implements OnInit, OnDestroy {

  alerts: Alert[];
  alertsSubscription: Subscription;

  constructor(
    private alertsService: AlertsService
  ) { }

  ngOnInit() {
    this.alertsSubscription = this.alertsService.alerts$.subscribe((alerts: Alert[]) => {
      const newAlerts = [];

      // retrieve last alerts from the alertsService
      const indexFirstAlert = alerts.length > CONSTANTS.ALERTS.MAX_DISPLAYED ? alerts.length - CONSTANTS.ALERTS.MAX_DISPLAYED : 0;
      for (let i = indexFirstAlert; i < alerts.length; i++) {
        newAlerts.push(alerts[i]);
      }

      // update the alerts
      this.alerts = newAlerts;
    });
  }

  ngOnDestroy() {
    if (this.alertsSubscription) { this.alertsSubscription.unsubscribe(); }
  }

}
